import {useDisclosure} from '@mantine/hooks';
import type {FC} from 'react';
import {MdAddCircleOutline} from 'react-icons/md';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {cn} from '../../../lib/classname';
import {NoLoginAlertModal} from '../NoLoginAlertModal';

type Props = {
  isClipped: boolean;
  handleClip: () => Promise<void>;
  count: number;
  className?: string;
};

export const ClipButtonTypeD: FC<Props> = ({
  isClipped,
  handleClip,
  count,
  className,
}) => {
  const {status} = useAuth();
  const [opened, {open, close}] = useDisclosure(false);

  const handleUpdate = async () => {
    if (status !== 'authenticated') {
      open();
      return;
    }

    await handleClip();
  };

  return (
    <>
      <ClipButtonTypeDPure
        className={className}
        onClick={handleUpdate}
        isClipped={isClipped}
        count={count}
      />
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};

type PureProps = {
  isClipped: boolean;
  onClick: () => void;
  count: number;
  className?: string;
};
/**
 * PureはContextに依存しないという意味
 */
export const ClipButtonTypeDPure: FC<PureProps> = ({
  className,
  onClick,
  count,
  isClipped,
}) => {
  return (
    <button
      className={cn(
        'h-[36px] pl-[6px] pr-12 py-[6px] rounded-[28px] border-2 border-primary text-primary inline-flex justify-center items-center gap-[2px]',
        isClipped && 'bg-primary text-white',
        className,
      )}
      type="button"
      onClick={onClick}
    >
      <MdAddCircleOutline
        size={20}
        className={cn('text-primary-1', isClipped && 'text-white')}
      />
      <span className="text-[12px] font-bold">{count}</span>
    </button>
  );
};
